<template>
  <div class="app-container openapi-catalog">
    <el-card class="box-card">
      <div class="page-title">对外接口清单</div>
      <div class="tip-box mb10">
        <i class="el-icon-info"></i>
        清单由<b>线上真实注册的路由</b>与<b>代码里的登记表</b>比对得出。
        标为「未登记」说明有人加了对外接口但没在 <code>OpenApiCatalog</code> 里登记；
        标为「已下线」说明接口删了但登记没清。两种都需要开发处理。
      </div>

      <el-table v-loading="loading" :data="list" :row-class-name="rowClass">
        <el-table-column label="接口路径" prop="path" align="left" min-width="240" show-overflow-tooltip />
        <el-table-column label="名称" prop="name" align="center" width="160">
          <template slot-scope="{row}">{{ row.name || '—' }}</template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="110">
          <template slot-scope="{row}">
            <el-tag size="mini" :type="stateTagType(row.state)">{{ stateText(row.state) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="用途" prop="purpose" align="left" min-width="240" show-overflow-tooltip>
          <template slot-scope="{row}">{{ row.purpose || '—' }}</template>
        </el-table-column>
        <el-table-column label="返回什么数据" prop="returns" align="left" min-width="280" show-overflow-tooltip>
          <template slot-scope="{row}">{{ row.returns || '—' }}</template>
        </el-table-column>
        <el-table-column label="方法" prop="method" width="80" />
        <el-table-column label="已授权接入方" min-width="180" show-overflow-tooltip>
          <template slot-scope="{row}">{{ (row.authorizedApps || []).map(k => k.appName + ' (#' + k.id + ')').join(', ') || '未授权' }}</template>
        </el-table-column>
        <el-table-column label="调用过的接入方" prop="callers" align="center" width="180" show-overflow-tooltip>
          <template slot-scope="{row}">{{ row.callers || '—' }}</template>
        </el-table-column>
        <el-table-column label="累计调用" prop="callCount" align="center" width="100" />
        <el-table-column label="最近调用" prop="lastCalledAt" align="center" width="160">
          <template slot-scope="{row}">{{ row.lastCalledAt || '从未调用' }}</template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import openApiManageApi from '@/api/openapi'

export default {
  name: 'OpenapiCatalog',
  data() {
    return {
      list: [],
      loading: false
    }
  },
  created() {
    this.doQueryList()
  },
  methods: {
    doQueryList() {
      this.loading = true
      return openApiManageApi.catalog()
        .then(data => {
          this.list = (data && data.data) || []
        })
        .finally(() => {
          this.loading = false
        })
    },
    stateText(state) {
      if (state === 'UNREGISTERED') return '未登记'
      if (state === 'OFFLINE') return '已下线'
      return '正常'
    },
    stateTagType(state) {
      if (state === 'UNREGISTERED') return 'danger'
      if (state === 'OFFLINE') return 'warning'
      return 'success'
    },
    rowClass({ row }) {
      // 需要人处理的两种状态整行标出来，不然混在正常行里没人会注意到
      return row.state === 'OK' ? '' : 'row-warn'
    }
  }
}
</script>

<style lang="scss" scoped>
.openapi-catalog {
  .page-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 12px;
  }
  .tip-box {
    font-size: 13px;
    color: #909399;
    line-height: 20px;
    code {
      background: #f5f7fa;
      padding: 0 4px;
      border-radius: 2px;
    }
  }
  ::v-deep .row-warn {
    background: #fdf6ec;
  }
}
</style>
